import React, { useMemo, useRef, useState } from 'react';
import { attachmentUrl } from './mailUtils';

const BASE_CSS = `<base target="_blank"><style>
body{margin:0;padding:4px 2px;font-family:Arial,Helvetica,sans-serif;font-size:14px;line-height:1.45;color:#0f172a;background:#fff;word-break:break-word}
img{max-width:100%;height:auto} blockquote{margin:0 0 0 .8ex;border-left:2px solid #cbd5e1;padding-left:1ex;color:#475569} pre{white-space:pre-wrap} table{max-width:100%}
a{color:#0369a1}</style>`;

const escapeHtml = (s) => (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const HtmlMail = ({ message }) => {
  const ref = useRef(null);
  const [h, setH] = useState(120);
  const doc = useMemo(() => {
    let html = message.html || `<div>${escapeHtml(message.text || message.snippet).replace(/\n/g, '<br>')}</div>`;
    Object.entries(message.inline || {}).forEach(([cid, attId]) => {
      const url = attachmentUrl({ message_id: message.id, id: attId, filename: cid });
      html = html.split(`cid:${cid}`).join(url);
    });
    return BASE_CSS + html;
  }, [message]);

  const measure = () => {
    try {
      const d = ref.current?.contentDocument;
      if (d?.body) setH(Math.min(Math.max(d.documentElement.scrollHeight, d.body.scrollHeight) + 16, 4000));
    } catch { /* cross-origin — keep default */ }
  };
  const onLoad = () => { measure(); [300, 1200, 3000].forEach(ms => setTimeout(measure, ms)); };

  return (
    <iframe ref={ref} title="message" srcDoc={doc} sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox" onLoad={onLoad}
      style={{ height: h }} className="w-full rounded-xl bg-white border-0" data-testid={`mail-html-${message.id}`} />
  );
};
